import { useTranslation } from 'react-i18n-lite'

import {
  AvatarContainer,
  AvatarInitials,
  AvatarPhoto,
  Card,
  ContactContent,
  ContactSubTitle,
  ContactTitle,
  Details,
  PhoneIcon
} from './styles'

import { ContactObjectCardProps } from './types'
import { getReadablePhoneNumber, getWhatsappNumber } from './utils'

const getInitials = (name: string) =>
  `${name.charAt(0).toUpperCase()}${name.split(' ').slice(-1)[0].charAt(0).toUpperCase()}`

const ContactObjectCard = ({
  avatarUrl,
  name,
  contactRole,
  phone,
  phoneIcon,
  email,
  ...divProps
}: ContactObjectCardProps) => {
  const { t } = useTranslation()

  return (
    <Card {...divProps}>
      <AvatarContainer>
        {avatarUrl ? (
          <AvatarPhoto src={avatarUrl} alt='' />
        ) : (
          <AvatarInitials aria-hidden>{getInitials(name)}</AvatarInitials>
        )}
      </AvatarContainer>
      <Details>
        <ContactTitle>{name}</ContactTitle>
        <ContactSubTitle>{contactRole}</ContactSubTitle>
        <ContactContent>
          {phone && (
            <a
              target='_blank'
              rel='noopener noreferrer'
              href={getWhatsappNumber(phone)}
            >
              {getReadablePhoneNumber(phone)}
            </a>
          )}
          {phoneIcon && (
            <PhoneIcon
              src={phoneIcon}
              alt={t('contact-object-card.phone-number')}
            />
          )}
          {(phone || phoneIcon) && <br />}
          {email && (
            <a
              target='_blank'
              rel='noopener noreferrer'
              href={`mailto:${email}`}
            >
              {email}
            </a>
          )}
        </ContactContent>
      </Details>
    </Card>
  )
}

export default ContactObjectCard
